export const SUPERTAG_DEFAULT_APPTOKEN = '20028716136f69533e19';
export const SUPERTAG_SERCOMM_APPTOKEN = 'd29b3be8f2cc9a1a7051';
export const SUPERTAG_GEN2_APPTOKEN = 'fafdf33f419367ee7921';

export const RTK02_HWID = '0A';
export const GEN2_HWID = '02';

export const supertagTok = [SUPERTAG_DEFAULT_APPTOKEN, SUPERTAG_SERCOMM_APPTOKEN, SUPERTAG_GEN2_APPTOKEN];

export const defaultTok = ['61697266696e64657200']